const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isLocalDev && port === '3000') {
      if (process.env.REACT_APP_RESPECT_LOCAL_API_URL === 'true' && process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
      }
      return 'http://localhost:8000';
    }

    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }

    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }

  return 'http://localhost:8000';
};

export const API_URL = getApiBaseUrl();

export interface User {
  id: string;
  name: string;
  avatar_url?: string;
}

export interface Message {
  id: string;
  content: string;
  sender: User;
  timestamp: string;
}

export interface Chat {
  id: string;
  participants: User[];
  lastMessage?: Message;
  unreadCount: number;
} 